import type { DebugAuditFile } from "./audit";

export const DEFAULT_STT_AUDIT_INGESTION_PATH = "/v1/stt/audits";
export const STT_AUDIT_INGESTION_RETRY_DELAYS_MS = [300, 600] as const;

export interface SttAuditIngestionConfig {
  endpoint?: string;
  threadId?: string;
  externalIdentifier?: string;
  headers?: Record<string, string>;
}

export interface SttAuditIngestionPayload {
  thread_id?: string;
  external_identifier?: string;
  stt_session_ids?: string[];
  audit: DebugAuditFile;
}

export type SttAuditIngestionWarningCode =
  | "missing_api_key"
  | "fetch_unavailable"
  | "invalid_endpoint"
  | "http_error"
  | "network_error"
  | "dispatch_failed";

export interface SttAuditIngestionWarning {
  code: SttAuditIngestionWarningCode;
  message: string;
  status?: number;
  attempt?: number;
  endpoint?: string;
  detail?: Record<string, unknown> | null;
}
